var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuitcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 5.75C3.01088 5.75 2.75 6.01088 2.75 6.33333V12.3333C2.75 12.6558 3.01088 12.9167 3.33333 12.9167H12.6667C12.9891 12.9167 13.25 12.6558 13.25 12.3333V6.33333C13.25 6.01088 12.9891 5.75 12.6667 5.75H3.33333ZM1.25 6.33333C1.25 5.18245 2.18245 4.25 3.33333 4.25H12.6667C13.8175 4.25 14.75 5.18245 14.75 6.33333V12.3333C14.75 13.4842 13.8175 14.4167 12.6667 14.4167H3.33333C2.18245 14.4167 1.25 13.4842 1.25 12.3333V6.33333Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46729 3.66659C4.46729 2.51571 5.39974 1.58325 6.55062 1.58325H9.44929C10.6002 1.58325 11.5326 2.51571 11.5326 3.66659V4.99992C11.5326 5.41413 11.1968 5.74992 10.7826 5.74992C10.3684 5.74992 10.0326 5.41413 10.0326 4.99992V3.66659C10.0326 3.34413 9.77174 3.08325 9.44929 3.08325H6.55062C6.22817 3.08325 5.96729 3.34413 5.96729 3.66659V4.99992C5.96729 5.41413 5.6315 5.74992 5.21729 5.74992C4.80307 5.74992 4.46729 5.41413 4.46729 4.99992V3.66659Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3741 5.92025C1.60224 5.57453 2.06745 5.47921 2.41317 5.70735L6.64717 8.50135C6.74243 8.56427 6.85428 8.598 6.96875 8.598H9.03142C9.14588 8.598 9.25745 8.56446 9.35271 8.50154L13.587 5.70735C13.9327 5.47921 14.3979 5.57453 14.6261 5.92025C14.8542 6.26597 14.7589 6.73118 14.4132 6.95932L10.1795 9.75313C10.1794 9.7532 10.1796 9.75307 10.1795 9.75313C9.83878 9.97809 9.4395 10.098 9.03142 10.098H6.96875C6.56066 10.098 6.16168 9.97828 5.821 9.75332C5.8209 9.75326 5.82109 9.75338 5.821 9.75332L1.587 6.95932C1.24127 6.73118 1.14595 6.26597 1.3741 5.92025Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuitcase);
export default __webpack_public_path__ + "static/media/icon-suitcase.4401dfeead8b620f99129f472d6cd925.svg";
export { ForwardRef as ReactComponent };